import axios from "axios";
import serverUrl from "@/auth.config.js";

axios.defaults.baseURL = `${serverUrl}/api`;
axios.defaults.headers.common.Authorization = localStorage.getItem('id_token');
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common.Accept = 'application/json';

export default {
    // Constants
    getConstants() {
        return axios.get('/const_dictionary');
    },

    getConstantsListByKey(key) {
        return axios.get('/const_dictionary-raw-key',{
          headers: {
            key:key
          }});
      },


    // Authentification
    setToken(token) {
        axios.defaults.headers.common.Authorization = token
    },
    login(email, password) {
        let formData = new FormData()
        formData.append('username', email)
        formData.append('password', password)

        return axios.post('/login/token', formData)
    },
    currentUser() {
        return axios.get(`/me`)
    },
    validateAccount(email, password, enc_token) {
        let formData = new FormData()
        formData.append('email', email)
        formData.append('enc_token', enc_token)
        formData.append('password', password)

        return axios.post('/validate-account', formData);
    },

    // Dashboard
//    isExistsPDFReport(repoId) {
//        return axios.get(`/report_pdf-exists/${repoId}`);
//    },

    // Thi function already exists, should be replaced by getRepositoryFile from api.js
//    getPDFUrl(repoId) {
//        return axios.get(`/report_pdf/${repoId}`, {responseType: 'blob'})
//    },

    getInstallationList() {
        return axios.get('/site-info');
    },

 //   getInstallationLoss(body = null) {
 //       return axios.get('/site-losses', {
 //           params: body
 //       });
 //   },

    // Dashboard MPP Graph
 //   getInstallationSubarrayTable(id, body) {
//        return axios.get(`/site-subarray-table`, {
//            params: {...body, ...{
//                installation_id: id
//            }}
//        })
//    },

//    getInstallationSubarrayGraph(id, lang_code, body) {
//        return axios.get(`/site-subarray-graph`, {
//            params: {...body, ...{installation_id: id, lang_code : lang_code}}
//        })
//    },

  //Get all incidents table
//    getIncidentTable(id, body) {
//        return axios.get(`/all_incidents_table`, {
//            params: {...body, ...{
//                installation_id: id
//            }}
//        })
//    },

    // Submit Audit
//    getFileRepository(repoId, file_type, rel_filepath, fileMime) {
//        return axios.get('/download-file', {
//                params: {
//                    "guid": repoId,
//                    "file_type": file_type,
//                    "filename": rel_filepath
//                },
//                responseType: 'blob',
//                header: {'content-type': fileMime}
//            })
//    },
//    removeFileRepository(repoId, filename) {
//        return axios.delete('/repository-file', {
//            params: {
//                "guid": repoId,
//                "filename": filename
//            }
//        })
//    },
//    uploadFile(file, conf_type, guid = "") {
//        let formData = new FormData()
//
//        // TODO: to change if multiple -> formData.append('file', file[0])
//        formData.append('file', file)
//        formData.append('conf_type', conf_type)
//        if(guid) formData.append('guid', guid)
//        return axios.post('/repository/upload-files', formData, {
//            headers: {
//                'Content-Type': 'multipart/form-data'
//              }
//        })
//    },
//    resetAudit(guid) {
//        return axios.get(`/repository/reset-uploaded-files/${guid}`)
//    },
//    storeAudit(guid, user_mail) {
//        let formData = new FormData()
//        formData.append('repo_id', guid)
//        formData.append('user_mail', user_mail)
//        return axios.post(`/workflow-submit`, formData, {
//            headers: {
//                'Content-Type': 'multipart/form-data'
//            }
//        })
//    },
//    getRepository() {
//        return axios.get('/repository')
//    },
//    getRepositoryUploadedFilesList(guid) {
//        return axios.get(`/repository/uploaded-files-list/${guid}`)
//    },


    // Expert Report Modules
    // A Décomissionner
//    getPdmList(install_id, pdm_type) {
//        return axios.get(`/installation-pdm`, {
//            params: {
//                install_id, pdm_type
//            }
//        })
//    },

//    hasPdmReport(module_name) {
//        return axios.get(`/report_module-has_pdm`, {
//            params: { module_name }
//        })
//    },

    getPdmCount(installation_id) {
        return axios.get(`/installation-pdm-count`, {
            params: { installation_id }
        })
    },

    getPdmTree(installation_id, lang_code){
        return axios.get(`/installation-pdm-tree_front_list`, {
            params: {
                installation_id, lang_code
            }
        })
    },

//    getExpertModTreePic(repo_id, module_name, lang_code){
//        return axios.get(`/expert_module-treepic`, {
//            params: {
//                guid: repo_id, module_name: module_name, lang_code: lang_code
//            }
//        })
//    },

//    getAnalystModTreePic(repo_id, module_name, lang_code){
//        return axios.get(`/analyst_module-treepic`, {
//            params: {
//                guid: repo_id, module_name: module_name, lang_code: lang_code
//            }
//        })
//    },

//    getAnalystModList(repo_id){
//        return axios.get(`/analyst_module-list`, {
//            params: {
//                guid: repo_id
//            }
//        })
//    },

//    getReportModuleList(module_type, compatibility_version) {
//        return axios.get(`/report_module-by_type`, {
//            params: { module_type, compatibility_version }
//        })
//    },

//    getReportFullName(module_name, target_menu) {
//        return axios.get(`/report_full-name`, {
//            params: { module_name, target_menu }
//        })
//    },


//    // Expert Modules (Old version)
//    getExpertModuleDate(installation_id, start_date, end_date) {
//        return axios.get(`/expert-module-date`, {
//            params: {
//                installation_id, start_date, end_date
//            }
//        })
//    },
    getExpertModuleInfos(module) {
        // module may be : heterogeneity, inverter, meteo, overheat, performance_ratio,
        //                 persistent, production, rating, shading
        return axios.get(`/expert_report-module`, {
            params: {
                module
            }
        })
    },
//    getGraphExpertModule(installation_id, module, start_time, end_time, sel_mpp) {
//       return axios.get('/graph-expert-module', {
//            params: {
//                installation_id, module, start_time, end_time, sel_mpp
//            }
//        })
//    },
//    getExpertModuleMpps(installation_id, start_date) {
//        return axios.get(`/expert-module-mpp`, {
//            params: {
//                installation_id, start_date
//            }
//        })
//    },

//    // Plotly Creator
//    getReportList() {
//        return axios.get('/report_template')
//    },

//    addNewReport(report_obj) {
//        return axios.post("/report_template", JSON.stringify(report_obj), {
//            headers: {
//                'Content-Type': 'application/json'
//            }
//        });
//    },

//    updateReport(report_obj) {
//        return axios.put(`/report_template/${String(report_obj['id'])}`, JSON.stringify(report_obj), {
//            headers: {
//                'Content-Type': 'application/json'
//            }
//        });
//    },

//    deleteReport(report_obj) {
//       return axios.delete(`/report_template/${String(report_obj['id'])}`, {
//            headers: {
//                'Content-Type': 'application/json'
//            }
//        });
//    },

//    getListunablemodexp(installation_id) {
//        return axios.get(`/list-unable-module/${String(installation_id)}`);
//    },

//    getReportDatasource() {
//        return axios.get('/report-datasource');
//    },

//    getGraphDatasource(query_param) {
//        return axios.get('/graph-datasource', {params: query_param});
//    },

//    getTemplateRenderByName(report_name, country_lang_code, query_param) {
//        const query = {
//            report_name, country_lang_code, query_param
//        }

//        return axios.post('/report_template-rendered', JSON.stringify(query), {
//            headers: {
//                'Content-Type': 'application/json'
//            }
//        });
//    },

//    getTemplateRenderByNameWithPower(report_name, country_lang_code, target_menu, query_param) {
//        const query = {
//            report_name, country_lang_code, target_menu, query_param
//        }

//        return axios.post('/report_site_evo_perf_detail', JSON.stringify(query), {
//            headers: {
//                'Content-Type': 'application/json'
//            }
//        });
//    },

//    // Feature Alarm
//    getChecklistCategories() {
//        return axios.get('/checklist_categories')
//    },

//    getChecklists(installation_id, date) {
//        return axios.get('/checklists', {
//            params: {installation_id, date}
//        })
//    },

//    getChecklistStatus(installation_id, date) {
//        return axios.get('/checklist-status', {
//            params: {installation_id, date}
//        })
//    },

//    getAlarmDetails(installation_id, date, period_type, status) {
//        return axios.get('/alarm_details', {
//            params: {installation_id, date, period_type, status}
//        })
//    },

//    getAlarmSumpUpStatus(installation_id, date, period_type, status) {
//        return axios.get('/alarm-sumup-status', {
//            params: {installation_id, date, period_type, status}
//        })
//    },

//    getAlarmIndicator(installation_id, date) {
//        return axios.get('/alarm-indicator-byday', {
//            params: {installation_id, date}
//        })
//    },

//    getAlarmLossTree(installation_id, date) {
//        return axios.get('/alarm-loss-tree-byday', {
//            params: {installation_id, date}
//        })
//    },

//    // NanoGUNE Virtual Sensor
//    getVirtualSensorFile(repoId, fileMime) {
//        return axios.get('/virtual-sensor', {
//                params: {
//                    "guid": repoId,
//                },
//                responseType: 'blob',
//                header: {'content-type': fileMime}
//            })
//    },

//    // PVSYST
//    calculatePvsystValue(jsonData, installation_id, start_date, end_date){
//        axios.defaults.headers.common['Content-Type'] = 'application/json';
//        let back = axios.post('/calculate_pvsyst',
//            jsonData, {
//                params: {
//                    "installation_id": installation_id,
//                    "start_date":start_date,
//                    "end_date": end_date
//                }
//            }
//        );
//        axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
//        return back
//    },

//    downloadPvsystData(jsonData, fileName, country_lang_code){
//        axios.defaults.headers.common['Content-Type'] = 'application/json';
//        let back = axios.post('/convert_pvsyst_json_xlsx',
//            jsonData,
//            {
//                params: { "file":fileName, "country_lang_code": country_lang_code },
//                responseType: 'blob'
//            }
//        );
//        axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
//        return back
//    },

//    convertkpiXlsxToJson(file){
//        let formData = new FormData();
//        formData.append('file', file);

//        return axios.post('/convert_kpi_xlsx_json', formData, {
//           headers: {
//             'Content-Type': 'multipart/form-data',
//           },
//         });

//    },
//
//    convertPvsystXlsxToJson(file){
//        let formData = new FormData();
//        formData.append('file', file);

//        return axios.post('/convert_pvsyst_xlsx_json', formData, {
//           headers: {
//             'Content-Type': 'multipart/form-data',
//           },
//         });

//    },

    // getkpiData(installation_id, payload){
    //     return axios.get('/get_kpi_data', {
    //         params: {installation_id, payload}
    //     })
    // },

//    getkpiData(jsonData, installation_id, start_date, end_date,pdm_list,min_irradiance){
//        axios.defaults.headers.common['Content-Type'] = 'application/json';
//        let back = axios.post('/get_kpi_data',
//            jsonData, {
//                params: {
//                  "installation_id": installation_id,
//                    "start_date":start_date,
//                    "end_date": end_date,
//                    "pdm_list": pdm_list,
//                    "min_irradiance":min_irradiance
//                }
//            }
//        );
//        axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
//        return back
//    },

    convertJson(jsonData, type, country_lang_code, data_type){
        axios.defaults.headers.common['Content-Type'] = 'application/json';
        let back = axios.post('/convert-json', 
            jsonData, 
            {
                params: { "country_lang_code": country_lang_code, "converter_type": type, "data_type": data_type }, 
                responseType: 'blob'
            }
        );
        axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
        return back
    },

    convertJsonIncident(jsonData, type, country_lang_code, data_type){
        axios.defaults.headers.common['Content-Type'] = 'application/json';
        let back = axios.post('/convert-json-incident', 
            jsonData, 
            {
                params: { "country_lang_code": country_lang_code, "converter_type": type, "data_type": data_type }, 
                responseType: 'blob'
            }
        );
        axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
        return back
    },

       //Expert module layout
       get_layout_model_global_info(id){
        return axios.get('/installation/'+id);
    },

    getlistparc(body) {
        return axios.post('/get-list-parc', body);     
    },

    getgraphevolution(body) {
        return axios.post('/get-graph-evolution', body);
    },

    getalertes(body) {
        return axios.post('/get-alertes', body);
    },
    
    getlistalarms(body) {
        return axios.post('/get-list-alarms', body);
    },
    
    get_nb_inv_per_model(id){
        return axios.get('/inv_count_by_model/'+id);
    },

    get_all_plane_information(id){
        return axios.get('/install_plane_info/'+id);
    },

    get_all_full_layout(id){
        return axios.get('/installation_layout/'+id);
    },

    convertJsonExpert(jsonData, type, data_type, moduleExpertName, country_lang_code){
        axios.defaults.headers.common['Content-Type'] = 'application/json';
        let back = axios.post('/convert-json',  
            jsonData, 
            {
                params: { "country_lang_code": country_lang_code, "converter_type": type, "data_type": data_type, "moduleExpertName": moduleExpertName  }, 
                responseType: 'blob'
            }
        );
        axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
        return back
    },

    convertJsonSousPerf(jsonData, type, data_type, country_lang_code){
        axios.defaults.headers.common['Content-Type'] = 'application/json';
        let back = axios.post('/convert-json',  
            jsonData, 
            {
                params: { "country_lang_code": country_lang_code, "converter_type": type, "data_type": data_type }, 
                responseType: 'blob'
            }
        );
        axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
        return back
    },

    async get_inv_model(){
        let all= await(axios.get('/conf_techno', {
            headers: { 'get-model': true }
          }))
            let res=all.data.filter(item => item.type==="inverter")
            return res
      
    },

    async get_building(){
        let all= await(axios.get('/conf_techno', {
            headers: { 'get-model': true }
          }))
            let res=all.data.filter(item => item.type==="building")
            return res
      
    },

    async get_installation(){
        let all= await(axios.get('/conf_techno', {
            headers: { 'get-model': true }
          }))
        let res=all.data.filter(item => item.type==="installation")
        return res
      
    },

    async get_integration(){
        let all= await(axios.get('/conf_techno', {
            headers: { 'get-model': true }
          }))
            let res=all.data.filter(item => item.type==="integration")
            return res
      
    },

    async get_pv_panel_model(){
        let all= await(axios.get('/conf_techno', {
            headers: { 'get-model': true }
          }))
            let res=all.data.filter(item => item.type==="pv-panel")
            return res
      
    },


}
